const globalStyles = `
.breadcrumb-custom {
  font-family: "Montserrat", sans-serif  !important;
  display: -webkit-box !important;
  display: -ms-flexbox !important;
  display: -webkit-flex !important;
  display: flex !important;
  -ms-flex-wrap:wrap !important;
      -webkit-flex-wrap:wrap !important;
          flex-wrap:wrap !important;
  -webkit-box-pack: center !important;
      -ms-flex-pack: center !important;
          -webkit-justify-content: center !important;
          justify-content: center !important;
  margin-bottom: 35px !important;  
  padding-left: 0px !important;
  font-size: 24px
  font-weight: 500;
}

.main-title {
  display: block;
  padding-right: 15px;
  text-align: center;
  font-family: Montserrat;
  font-size: 35px;
  font-weight: 500;
  margin-top: 20px;
  margin-bottom: 5px;
}

.board-tramite {
  border: 0.5px solid #b3b3b3;
  border-radius: 4.5px;
}

.width-button-send {
  width: 360px;
}

.breadcrumb-level::before, .breadcrumb-level::after {
  content: '' !important;
  position: absolute !important;
  left: 0 !important;
  height: 50% !important;
  width: 100% !important;
  background: #CACACA !important;
  z-index: -1 !important;
}
.breadcrumb-level::before {
  top: 0 !important;
  -webkit-transform: skew(20deg) !important;
          transform: skew(20deg) !important;
}
.breadcrumb-level::after {
  bottom: 0 !important;
  -webkit-transform: skew(-20deg) !important;
          transform: skew(-20deg) !important;
}

.breadcrumb-level {
  display: inline-block !important;
  position: relative !important;
  margin-right: 5px !important;
}
.breadcrumb-level:last-child a {
  cursor: default !important;
}

.breadcrumb-level a {
  display: inline-block !important;
  position: relative !important;
  line-height: 1.8 !important;
  padding: 0 170px !important;
  padding-left: 28px!important;
  color: #fff !important;
  text-decoration: none !important;
}

.breadcrumb-level-active::before, .breadcrumb-level-active::after {
  content: '' !important;
  position: absolute !important;
  left: 0 !important;
  height: 50% !important;
  width: 100% !important;
  background: #444 !important;
  z-index: -1 !important;
}
.breadcrumb-level-active::before {
  top: 0 !important;
  -webkit-transform: skew(20deg) !important;
          transform: skew(20deg) !important;
}
.breadcrumb-level-active::after {
  bottom: 0 !important;
  -webkit-transform: skew(-20deg) !important;
          transform: skew(-20deg) !important;
}

.breadcrumb-level-active {
  display: inline-block !important;
  position: relative !important;
  margin-right: 5px !important;
}
.breadcrumb-level-active:last-child a {
  cursor: default !important;
}

.breadcrumb-level-active a {
  display: inline-block !important;
  position: relative !important;
  line-height: 1.8 !important;
  padding: 0 170px !important;
  padding-left: 28px!important;
  color: #fff !important;
  text-decoration: none !important;
}

.date-picker-custom {
  border: 1px solid #30bdbb !important;
  border-radius: 0 !important;
  font-size: 14px !important;
  font-family: Montserrat !important;
  width: 200px !important;
  padding: 7px !important;
}

.item-menu-footer {
  width: 228px;
  font-size: 15px;
}

.modal-info {
  text-align: justify;
}


select {
  -webkit-appearance: none;
  -moz-appearance: none;
  background: transparent;
  background-image: url("data:image/svg+xml;utf8,<svg fill='black' height='24' viewBox='0 0 24 24' width='24' xmlns='http://www.w3.org/2000/svg'><path d='M7 10l5 5 5-5z'/><path d='M0 0h24v24H0z' fill='none'/></svg>");
  background-repeat: no-repeat;
  background-position-x: 100%;
  background-position-y: 5px;
  border: 1px solid #dfdfdf;
  border-radius: 2px;
  margin-right: 2rem;
  padding: 1rem;
  padding-right: 2rem;
}

.header-boder {
  border-bottom: 1px solid #B3B3B3; 
  padding-bottom: 1em;
}

.has-error {
  border: 1px solid red!important;
}

.error-label {
  color: red;
  font-family: "Montserrat";
  font-weight: 500
}

.disclaimer {
  text-align: justify;
  width: 87%;
}

.img-cedula {
  width: 40%;
}

.btn-style-add-one {
  background-color: white !important;
  border: 1px solid #17a2b8 !important;
  border-width: 3px !important;
  color: #17a2b8 !important;
}

.information-card {
    background: #fff;
    padding: 2em;
    border-top: 3px solid #b8b8b8;
    border-bottom: 3px solid #b8b8b8;
    margin-bottom: 2em;
}

.information-card__title {
  color: #202428;
  font-size: 28px;
  font-weight: 700;
  margin-bottom: 15px;
}

.link-readmore {
  color: #0D4B71;
  font-weight: 700;
}

.sub-title {
  display: block;
  padding-right: 15px;
  background:  transparent;
  text-align: center;
  font-family: Montserrat;
  font-size: 24px;
  font-weight: 500;
}

.font-step {
  font-size: 23px;
}


@media (max-width: 736px)  {

  .breadcrumb-level {
    width: 150px !important;
  }

  .breadcrumb-level-active {
    width: 150px !important;
  }

  .breadcrumb-level-active a {
    padding: 0px !important;
    padding-top: 15px !important;
    padding-bottom: 15px !important;
    padding-left: 20px !important;
  }

  .breadcrumb-level a {
    padding: 0px !important;
    padding-top: 15px !important;
    padding-bottom: 15px !important;
    padding-left: 20px !important;
  }

  .disclaimer {
    text-align: justify;
    width: 100%;
  }

  .img-cedula {
    width: 100%;
  }

  .mb-mobile {
    margin-bottom: 20px;
  }

  .label-aprox-registro {
    font-size: 15px;
    width: 250px;
  }

  .width-input-mobile {
    width: 90%;
  }

  .margin-top-mobile {
    margin-bottom: 20px;
  }

  .font-step {
    font-size: 16px;
  }

  .last-item {
    width: 228px;
  }

}

@media (max-width: 414px) {
  .navbar-brand {
    margin-left: 10px;
  }

  .disclaimer {
    text-align: justify;
    width: 100%;
  }

  .img-cedula {
    width: 100%;
  }

  .mb-mobile {
    margin-bottom: 20px;
  }

  .label-aprox-registro {
    font-size: 15px;
    width: 250px;
  }

  .width-input-mobile {
    width: 90% !important;
  }

  .margin-bottom-mobile {
    margin-bottom: 10px;
  }
  
  .board-tramite {
    border: none;
    border-radius: none;
  }

  .main-title {
    display: block;
    padding-right: 0px !important;
    text-align: center;
    font-family: Montserrat;
    font-size: 18px;
    font-weight: 500;
    margin-top: 10px;
    margin-bottom: 10px;
  }

  .sub-title {
    display: block;
    padding-right: 0px !important;
    background:  transparent;
    text-align: center;
    font-family: Montserrat;
    font-size: 16px;
    font-weight: 500;
  }

  .font-size-mobile-title {
    font-size: 14px !important;
    padding-right: 0px !important;
  }


  .margin-top-mobile {
    margin-bottom: 10px;
  }

  .header-boder {
    border-bottom: 1px solid #B3B3B3; 
    padding-bottom: 0px;
  }

  .last-item {
    width: 228px;
  }

}

#by-TramitaYa > tspan {
  padding-right: 1px;
}
`

export default globalStyles
